// LUMINA · pages/vajra/admin/SchedulesSection.jsx
// Phase 40: 定期共修管理 — Staff CRUD for RecurringSchedule

import React, { useState, useEffect } from 'react';
import { API, GD, TXT, TXT2, PANEL } from '../constants';
import { VajraBtn } from '../primitives';

const RECURRENCE_OPTIONS = [
  { value: "weekly_sat", label: "每周六" },
  { value: "weekly_sun", label: "每周日" },
  { value: "weekly_fri", label: "每周五" },
  { value: "weekly",     label: "每周（自定义星期）" },
  { value: "biweekly",   label: "每两周" },
  { value: "monthly",    label: "每月" },
  { value: "custom",     label: "不定期" },
];

const WEEKDAY_ZH = ["周一","周二","周三","周四","周五","周六","周日"];

const TZ_OPTIONS = [
  "America/Toronto","America/Vancouver","America/New_York","America/Los_Angeles",
  "Asia/Shanghai","Asia/Hong_Kong","Europe/London","UTC",
];

const RECURRENCE_LABELS = {
  weekly_sat:"每周六", weekly_sun:"每周日", weekly_fri:"每周五",
  weekly:"每周", biweekly:"每两周", monthly:"每月", custom:"不定期",
};

const BLANK = {
  title_zh:"", title_en:"", description:"", teacher_zh:"", teacher_id:"",
  location:"", online_link:"", recurrence:"weekly_sat", day_of_week:"",
  time_start:"", time_end:"", timezone:"America/Toronto", custom_rule:"",
  is_active:true, next_date:"", teaching_id:"", element_affinity:"",
};

export default function SchedulesSection({ token, headers, teacherList, teachingList }) {
  const [schedules, setSchedules] = useState([]);
  const [form, setForm] = useState(BLANK);
  const [editId, setEditId] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const d = await fetch(`${API}/vajra/schedules`).then(r => r.ok ? r.json() : []).catch(() => []);
    setSchedules(Array.isArray(d) ? d : []);
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      teacher_id:  form.teacher_id  ? parseInt(form.teacher_id)  : null,
      teaching_id: form.teaching_id ? parseInt(form.teaching_id) : null,
      day_of_week: form.day_of_week !== "" ? parseInt(form.day_of_week) : null,
    };
    const url    = editId ? `${API}/vajra/staff/schedules/${editId}` : `${API}/vajra/staff/schedules`;
    const method = editId ? "PUT" : "POST";
    const r = await fetch(url, { method, headers, body: JSON.stringify(payload) });
    if (r.ok) {
      setMsg(editId ? "✓ 已更新" : "✓ 已添加");
      setEditId(null); setForm(BLANK); load();
    } else {
      const d = await r.json(); setMsg("✗ " + (d.detail || "操作失败"));
    }
  };

  const del = async (id) => {
    if (!window.confirm("确认停用？")) return;
    await fetch(`${API}/vajra/staff/schedules/${id}`, { method: "DELETE", headers });
    load();
  };

  const startEdit = (s) => {
    setEditId(s.id);
    setForm({
      title_zh: s.title_zh, title_en: s.title_en || "", description: s.description || "",
      teacher_zh: s.teacher_zh || "", teacher_id: s.teacher_id || "",
      location: s.location || "", online_link: s.online_link || "",
      recurrence: s.recurrence, day_of_week: s.day_of_week ?? "",
      time_start: s.time_start || "", time_end: s.time_end || "",
      timezone: s.timezone || "America/Toronto", custom_rule: s.custom_rule || "",
      is_active: s.is_active, next_date: s.next_date || "",
      teaching_id: s.teaching_id || "", element_affinity: s.element_affinity || "",
    });
  };

  const inp = { width:"100%", padding:"7px 10px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:7, fontSize:13, background:"#fff", boxSizing:"border-box" };
  const lbl = { fontSize:10, color:"#aaa", letterSpacing:1, display:"block", marginBottom:3 };
  const needsCustomWeekday = form.recurrence === "weekly";
  const needsCustomRule    = form.recurrence === "custom";

  return (
    <div style={{ background: PANEL, borderRadius: 12, padding: "20px", border: "1px solid rgba(0,0,0,0.06)" }}>
      <div style={{ fontSize: 14, color: GD, marginBottom: 4 }}>定期共修管理</div>
      <div style={{ fontSize: 11, color: "#aaa", marginBottom: 16 }}>
        管理每周固定共修日程。创建后将显示在法讯「定期共修」视图及公开日历页面。
      </div>
      {msg && (
        <div style={{ fontSize:13, padding:"8px 12px", borderRadius:8, marginBottom:12,
          background: msg.startsWith("✗") ? "rgba(220,38,38,0.08)" : "rgba(5,150,105,0.08)",
          color: msg.startsWith("✗") ? "#dc2626" : "#059669" }}>
          {msg}
        </div>
      )}

      {/* Form */}
      <form onSubmit={save} style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:24, padding:"16px", background:"rgba(212,175,55,0.04)", borderRadius:10, border:"1px solid rgba(212,175,55,0.15)" }}>
        <div style={{ gridColumn:"1/-1", fontSize:12, color:GD, fontWeight:600, marginBottom:4 }}>
          {editId ? "编辑定期共修" : "新建定期共修"}
        </div>

        <div style={{ gridColumn:"1/-1" }}>
          <label style={lbl}>共修名称（中文）*</label>
          <input value={form.title_zh} onChange={e => setForm({...form, title_zh: e.target.value})} required placeholder="如：度母线下共修" style={inp}/>
        </div>
        <div>
          <label style={lbl}>名称（英文）</label>
          <input value={form.title_en} onChange={e => setForm({...form, title_en: e.target.value})} style={inp}/>
        </div>
        <div>
          <label style={lbl}>主持上师（文字）</label>
          <input value={form.teacher_zh} onChange={e => setForm({...form, teacher_zh: e.target.value})} placeholder="格西嘉滇" style={inp}/>
        </div>

        <div>
          <label style={lbl}>关联上师档案</label>
          <select value={form.teacher_id} onChange={e => setForm({...form, teacher_id: e.target.value})} style={inp}>
            <option value="">— 不指定 —</option>
            {(teacherList || []).map(t => <option key={t.id} value={t.id}>{t.name_zh}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>周期 *</label>
          <select value={form.recurrence} onChange={e => setForm({...form, recurrence: e.target.value})} required style={inp}>
            {RECURRENCE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>

        {needsCustomWeekday && (
          <div>
            <label style={lbl}>具体星期</label>
            <select value={form.day_of_week} onChange={e => setForm({...form, day_of_week: e.target.value})} style={inp}>
              <option value="">— 选择 —</option>
              {WEEKDAY_ZH.map((d, i) => <option key={i} value={i}>{d}</option>)}
            </select>
          </div>
        )}

        {needsCustomRule && (
          <div style={{ gridColumn:"1/-1" }}>
            <label style={lbl}>自定义规则</label>
            <input value={form.custom_rule} onChange={e => setForm({...form, custom_rule: e.target.value})} placeholder="如：每月初一、十五" style={inp}/>
          </div>
        )}

        <div>
          <label style={lbl}>开始时间（HH:MM）</label>
          <input type="time" value={form.time_start} onChange={e => setForm({...form, time_start: e.target.value})} style={inp}/>
        </div>
        <div>
          <label style={lbl}>结束时间（HH:MM）</label>
          <input type="time" value={form.time_end} onChange={e => setForm({...form, time_end: e.target.value})} style={inp}/>
        </div>

        <div>
          <label style={lbl}>时区</label>
          <select value={form.timezone} onChange={e => setForm({...form, timezone: e.target.value})} style={inp}>
            {TZ_OPTIONS.map(tz => <option key={tz} value={tz}>{tz}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>下次日期（YYYY-MM-DD）</label>
          <input type="date" value={form.next_date} onChange={e => setForm({...form, next_date: e.target.value})} style={inp}/>
        </div>

        <div style={{ gridColumn:"1/-1" }}>
          <label style={lbl}>地点</label>
          <input value={form.location} onChange={e => setForm({...form, location: e.target.value})} placeholder="如：多伦多 XXX 社区中心 / 线上" style={inp}/>
        </div>
        <div style={{ gridColumn:"1/-1" }}>
          <label style={lbl}>线上链接</label>
          <input value={form.online_link} onChange={e => setForm({...form, online_link: e.target.value})} placeholder="Zoom / 腾讯会议 URL" style={inp}/>
        </div>

        <div>
          <label style={lbl}>关联法教</label>
          <select value={form.teaching_id} onChange={e => setForm({...form, teaching_id: e.target.value})} style={inp}>
            <option value="">— 不关联 —</option>
            {(teachingList || []).map(t => <option key={t.id} value={t.id}>{t.title_zh}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>五行属性</label>
          <input value={form.element_affinity} onChange={e => setForm({...form, element_affinity: e.target.value})} placeholder="如：土/Yellow Tara" style={inp}/>
        </div>

        <div style={{ gridColumn:"1/-1" }}>
          <label style={lbl}>简介</label>
          <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} rows={2} style={{ ...inp, resize:"vertical" }}/>
        </div>

        <div style={{ gridColumn:"1/-1", display:"flex", gap:8 }}>
          <VajraBtn type="submit">{editId ? "保存修改" : "创建共修"}</VajraBtn>
          {editId && (
            <button type="button" onClick={() => { setEditId(null); setForm(BLANK); }} style={{ padding:"7px 16px", borderRadius:8, border:"1px solid #ddd", background:"#fff", fontSize:13, cursor:"pointer", color:TXT2 }}>
              取消
            </button>
          )}
        </div>
      </form>

      {/* List */}
      {schedules.length === 0 ? (
        <div style={{ fontSize:13, color:TXT2, textAlign:"center", padding:"20px 0" }}>暂无定期共修安排</div>
      ) : (
        schedules.map(s => (
          <div key={s.id} style={{ display:"flex", alignItems:"flex-start", gap:10, padding:"14px 16px", borderRadius:10, marginBottom:8, background:"rgba(212,175,55,0.03)", border:"1px solid rgba(212,175,55,0.1)" }}>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ fontSize:14, color:TXT, fontWeight:600 }}>{s.title_zh}</span>
                <span style={{ fontSize:10, color:"#064E3B", background:"rgba(6,78,59,0.07)", border:"1px solid rgba(6,78,59,0.15)", borderRadius:10, padding:"1px 8px" }}>
                  {RECURRENCE_LABELS[s.recurrence] || s.recurrence}
                </span>
              </div>
              <div style={{ fontSize:11, color:TXT2, marginTop:3 }}>
                {s.next_date && `📅 ${s.next_date}  `}
                {s.time_start && `⏰ ${s.time_start}${s.time_end ? `–${s.time_end}` : ""}`}
                {s.timezone && ` · ${s.timezone}`}
              </div>
              {s.teacher_zh && <div style={{ fontSize:11, color:"#999", marginTop:2 }}>🪷 {s.teacher_zh}</div>}
              {s.location   && <div style={{ fontSize:11, color:"#999", marginTop:2 }}>📍 {s.location}</div>}
            </div>
            <div style={{ display:"flex", gap:6, flexShrink:0 }}>
              <button onClick={() => startEdit(s)} style={{ padding:"4px 12px", borderRadius:6, border:`1px solid ${GD}44`, background:"transparent", color:GD, fontSize:11, cursor:"pointer" }}>编辑</button>
              <button onClick={() => del(s.id)} style={{ padding:"4px 12px", borderRadius:6, border:"1px solid rgba(220,38,38,0.3)", background:"transparent", color:"#dc2626", fontSize:11, cursor:"pointer" }}>停用</button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
